<template>
  <div class="logo" :class="{'primary-logo': isPrimary, 'secondary-logo': !isPrimary, 'text-only': TextOnly, 'list': !useGrid}">
    <div v-if="HasLogo" class="branding-logo-container">
      <img class="img" :src="GetLogoPath" id="logoImg" alt="logoImg"/>
    </div>
    <div v-else class="logo-underwriter-name">
      <h2 class="container-heading" v-if="isPrimary">
        {{Name}}
      </h2>
      <span v-else>
        {{underwriterLogo.FullName}}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Constants from '@/utils/constants';

// Define component options
defineOptions({
  name: 'branding-group-logo'
});

// Define props
const props = defineProps({
  isPrimary: {
    type: Boolean,
    required: false,
    default: false,
  },
  underwriterLogo: {
    type: Object,
    required: true,
  },
  useGrid: {
    type: Boolean,
    required: false,
    default: true,
  },
});

// Computed properties
const HasLogo = computed(() => {
  return props.underwriterLogo.BrandingGroupItem !== null && props.underwriterLogo.BrandingGroupItem.LogoPath;
});

const GetLogoPath = computed(() => {
  return props.underwriterLogo.BrandingGroupItem.LogoPath;
});

const IsIssuerLogoType = computed(() => {
  return props.underwriterLogo.BrandingGroupItem && (props.underwriterLogo.BrandingGroupItem.LogoType & Constants.BrandingLogoTypes.Issuer) != 0;
});

const Name = computed(() => {
  if (IsIssuerLogoType.value) {
    return props.underwriterLogo.BrandingGroupItem.IssuerName;
  }
  return props.underwriterLogo.FullName;
});

const TextOnly = computed(() => {
  return !HasLogo.value && !props.useGrid;
});
</script>

<style lang="stylus" scoped>
@import '~@/shared/styles/HeroContent.scss';
  img {
    display: flex;
    object-fit: scale-down;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }

  .logo-underwriter-name {
    color: black;
    font: 'sans serif';
    font-size: 20px;
  }

  .secondary-logo {
    width: 100px;
    display: flex;
    justify-content: center;
    height: 72px;

    &.text-only {
      width: 100%;
      word-wrap: none;
      height: auto !important;
    }

    .branding-logo-container {
      max-height: 100%;
      max-width: 100%;
      margin: auto;
      display: flex;
    }
  }

  .list {
    margin-bottom: 16px;
  }

  .primary-logo {
    height: 128px;
    max-width: 200px;
    margin-bottom: 48px;
    object-fit: scale-down;
    display: flex;

    &.text-only {
      width: 100%;
      max-width: 100%;
    }

    .logo-underwriter-name {
      color: black;
      font: 'sans serif';
      font-size: 20px;
    }
  }
  .container-heading {
    padding: 0 !important;
    color: #43425D;    
    font-size: 26px;
    font-family: 'Lato Bold', sans-serif;
    text-transform: none;
  }
</style>>
